/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetMarketsRegionIdHistory200Ok
 */
export interface GetMarketsRegionIdHistory200Ok {
    /**
     * average number
     * @type {number}
     * @memberof GetMarketsRegionIdHistory200Ok
     */
    average: number;
    /**
     * The date of this historical statistic entry
     * @type {Date}
     * @memberof GetMarketsRegionIdHistory200Ok
     */
    date: Date;
    /**
     * highest number
     * @type {number}
     * @memberof GetMarketsRegionIdHistory200Ok
     */
    highest: number;
    /**
     * lowest number
     * @type {number}
     * @memberof GetMarketsRegionIdHistory200Ok
     */
    lowest: number;
    /**
     * Total number of orders happened that day
     * @type {number}
     * @memberof GetMarketsRegionIdHistory200Ok
     */
    orderCount: number;
    /**
     * Total
     * @type {number}
     * @memberof GetMarketsRegionIdHistory200Ok
     */
    volume: number;
}

/**
 * Check if a given object implements the GetMarketsRegionIdHistory200Ok interface.
 */
export function instanceOfGetMarketsRegionIdHistory200Ok(value: object): value is GetMarketsRegionIdHistory200Ok {
    if (!('average' in value) || value['average'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('highest' in value) || value['highest'] === undefined) return false;
    if (!('lowest' in value) || value['lowest'] === undefined) return false;
    if (!('orderCount' in value) || value['orderCount'] === undefined) return false;
    if (!('volume' in value) || value['volume'] === undefined) return false;
    return true;
}

export function GetMarketsRegionIdHistory200OkFromJSON(json: any): GetMarketsRegionIdHistory200Ok {
    return GetMarketsRegionIdHistory200OkFromJSONTyped(json, false);
}

export function GetMarketsRegionIdHistory200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMarketsRegionIdHistory200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'average': json['average'],
        'date': (new Date(json['date'])),
        'highest': json['highest'],
        'lowest': json['lowest'],
        'orderCount': json['order_count'],
        'volume': json['volume'],
    };
}

export function GetMarketsRegionIdHistory200OkToJSON(json: any): GetMarketsRegionIdHistory200Ok {
    return GetMarketsRegionIdHistory200OkToJSONTyped(json, false);
}

export function GetMarketsRegionIdHistory200OkToJSONTyped(value?: GetMarketsRegionIdHistory200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'average': value['average'],
        'date': ((value['date']).toISOString().substring(0,10)),
        'highest': value['highest'],
        'lowest': value['lowest'],
        'order_count': value['orderCount'],
        'volume': value['volume'],
    };
}

